import React from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api/documents';
import '../styles/AdminHeader.css';

function AdminHeader() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authAPI.logout();
    } catch (e) {
      // Session cleanup is best-effort; still clear the client state.
    }
    localStorage.removeItem('adminAuth');
    localStorage.removeItem('adminUser');
    navigate('/dashboard/login');
  };

  const adminUser = localStorage.getItem('adminUser') || 'Admin';

  return (
    <header className="admin-header">
      <div className="admin-header-container">
        <div className="admin-brand">
          <div className="admin-icon">⚙️</div>
          <div className="admin-title">
            <h1>Robolog Admin Panel</h1>
            <p>Document Management System</p>
          </div>
        </div>

        <div className="admin-user-section">
          <div className="admin-user-info">
            <span className="user-icon">👤</span>
            <span className="user-name">{adminUser}</span>
          </div>
          <button onClick={handleLogout} className="btn-logout">
            🚪 Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default AdminHeader;
